import { Enviroment } from '../../../../../../_config/constants/enviroment-v2.constant';
import { getStatusNumber } from './get-status-number.handle';

export const getStatusDetail = (status) => {
	const reason = status?.reason ? `${status.reason}` : 'no especificado';
	return status?.status ? getStatusNumber(reason)[Enviroment.LANGUAGE][status.status] : 'Estado de solicitud no reconocido';
};
